import { render, staticRenderFns } from "./TokenInvalid.vue?vue&type=template&id=ffb9e91c&scoped=true"
import script from "./TokenInvalid.vue?vue&type=script&lang=js"
export * from "./TokenInvalid.vue?vue&type=script&lang=js"
import style0 from "./TokenInvalid.vue?vue&type=style&index=0&id=ffb9e91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb9e91c",
  null
  
)

export default component.exports